export const containsMinLength = (x) => /.{8,}/g.test(x);
export const containsNumbers = (x) => /[0-9]/g.test(x);
export const containsLowercase = (x) => /[a-z]/g.test(x);
export const containsUppercase = (x) => /[A-Z]/g.test(x);
export const containsSpecialCharacters = (x) => /[@#$%&*_\-+=<>]/g.test(x);
export const containsRepeatedNumbers = (x) => /(.)\1{2,}/g.test(x);
export const containsForbidenCharacters = (x) => /[^\w@#$%&*_\-+=<>]/g.test(x);
export const containsSequenceOfNumbers = function (s) {
  for (var i in s) {
    if (+s[+i + 1] === +s[i] + 1 && +s[+i + 2] === +s[i] + 2) {
      return ""
        .concat(+s[i], "")
        .concat(+s[i] + 1, "")
        .concat(+s[+i + 2]);
    }
  }
  return false;
};

function testPasswordForce(password = "") {
  password = password.trim();
  let passwordStrengthClass = "";

  if (
    !containsMinLength(password) ||
    !containsLowercase(password) ||
    containsRepeatedNumbers(password) ||
    containsSequenceOfNumbers(password) ||
    containsForbidenCharacters(password)
  ) {
    return "weak";
  }
  if (
    containsMinLength(password) &&
    containsNumbers(password) &&
    containsLowercase(password)
  ) {
    passwordStrengthClass = "medium";
    if (containsUppercase(password) || containsSpecialCharacters(password)) {
      passwordStrengthClass = "strong";
      if (containsUppercase(password) && containsSpecialCharacters(password)) {
        passwordStrengthClass = "stronger";
      }
    }
  }
  return passwordStrengthClass;
}

export const getDomainName = (hostName = window.location.hostname) => {
  const arr = hostName.split(".");
  return  arr.slice(1).join(".");
};
export default testPasswordForce;
